module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-support-detail.51377b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-support-detail.svg
// module id = 1791
// module chunks = 1